import type { AuthContextType } from '@/type/auth'
import { createContext } from 'react'

const AuthContext = createContext<AuthContextType>({
  status: 'unready',
  user: null,
  init: () => new Promise(() => {}),
  register: () => new Promise(() => {}),
  login: () => new Promise(() => {}),
  loginFromSDK: () => new Promise(() => {}),
  logout: () => {},
  updateUserInfo: () => new Promise(() => {}),
  refreshUserInfo: () => new Promise(() => {})
})

export default AuthContext
